
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.8647 0.366363C12.3532 -0.122121 13.1452 -0.122121 13.6336 0.366363C14.1221 0.854846 14.1221 1.64683 13.6336 2.13532L2.13549 13.6335C1.64701 14.122 0.855029 14.122 0.366549 13.6335C-0.121932 13.145 -0.121932 12.3531 0.366549 11.8646L11.8647 0.366363Z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M13.6335 11.8647C14.1219 12.3532 14.1219 13.1452 13.6335 13.6336C13.145 14.1221 12.353 14.1221 11.8645 13.6336L0.36636 2.13543C-0.12212 1.64694 -0.12212 0.854955 0.366361 0.366471C0.854842 -0.122012 1.64683 -0.122012 2.13531 0.366472L13.6335 11.8647Z","fill":"#C4C4C4"}})])
          )
        }
      }
    